import { TPublicUser } from 'types/publicUser';

interface PageSpecificMetadata {
  title?: string;
  description?: string;
}

export function getCommonMetaTags(
  pageSpecificMetadata: PageSpecificMetadata,
  publicUser: TPublicUser,
) {
  const title = pageSpecificMetadata?.title || publicUser?.business_name;

  let description;

  if (pageSpecificMetadata?.description) {
    description = pageSpecificMetadata.description;
  } else if (
    publicUser?.business_name &&
    publicUser?.preferences?.online_booking_disabled
  ) {
    description = publicUser.preferences.online_booking_disabled
      ? `View ${publicUser.business_name}'s services and prices online on GlossGenius`
      : `You can book ${publicUser.business_name} on GlossGenius.`;
  }

  const image =
    publicUser?.cover_image_original ||
    'https://static.glossgenius.com/public/core-mobile-and-web/static-images/gg_square_icon_512.png';

  const metaTags = [
    <meta httpEquiv="x-ua-compatible" content="ie=edge" key="httpequiv" />,
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1"
      key="viewport"
    />,
    <meta property="og:type" content="website" key="og-type" />,
    <meta property="fb:app_id" content="342526522936658" key="fb-id" />,
    <meta name="twitter:card" content="summary" key="twitter-card" />,
    <meta name="twitter:site" content="@glossgenius" key="twitter-site" />,
    <meta
      name="keywords"
      content="stylist,glossgenius,beauty"
      key="keywords"
    />,
  ];

  if (title) {
    metaTags.push(<title key="title">{title}</title>);
    metaTags.push(<meta property="og:title" content={title} key="og-title" />);
    metaTags.push(
      <meta name="twitter:title" content={title} key="twitter-title" />,
    );
  }

  if (description) {
    metaTags.push(
      <meta name="description" content={description} key="description" />,
    );
    metaTags.push(
      <meta
        property="og:description"
        content={`${description}`}
        key="og-description"
      />,
    );
    metaTags.push(
      <meta
        name="twitter:description"
        content={`${description}`}
        key="twitter-description"
      />,
    );
  }

  if (image) {
    metaTags.push(
      <meta property="og:image" content={`${image}`} key="og-image" />,
    );
    metaTags.push(
      <meta name="twitter:image" content={`${image}`} key="twitter-image" />,
    );
  }

  if (process.env.NODE_ENV !== 'production') {
    metaTags.push(<meta name="robots" content="noindex" key="noindex" />);
  }

  return metaTags;
}
